import useTest from "../../hooks/useTest";
import NewHomepage from "../NewHomepage";
import ShorterHomepage from "../ShorterHomepage";
import React, { useEffect } from "react";

export default function AdsLandingPage({ clientId, openLogin, showFront, hideFront }) {
  const [variationId] = useTest({
    clientId: clientId, //
    key: "ads_landing_homepage",
    variations: ["long", "short"],
  });

  useEffect(() => {
    showFront();

    return (() => {
      hideFront();
    });
  }, []);

  return (
    <>
      {variationId === "long" && (
        <NewHomepage
          openLogin={openLogin}
          clientId={clientId}
        />
      )}

      {variationId === "short" && (
        <ShorterHomepage
          openLogin={openLogin}
          clientId={clientId}
        />
      )}
    </>
  );
}
